/**
 * Custom lazy load for dropdown menu images
 * Loads images after clicking any menu item in #menu-top-menu or #menu-main-menu
 */

(function() {
  let imagesLoaded = false;
  
  /**
   * Load all dropdown images by replacing data-dropdown-img-src with src
   * Also handles srcset and sizes for responsive images
   */
  function loadDropdownImages() {
    if (imagesLoaded) return;
    
    // Find all dropdown images that haven't been loaded yet
    const dropdownImages = document.querySelectorAll('img[data-dropdown-img-src]:not([src])');
    
    if (dropdownImages.length === 0) {
      imagesLoaded = true;
      return;
    }
    
    dropdownImages.forEach(img => {
      const src = img.getAttribute('data-dropdown-img-src');
      const srcset = img.getAttribute('data-dropdown-img-srcset');
      const sizes = img.getAttribute('data-dropdown-img-sizes');
      
      // Set the src to load the image
      if (src) {
        img.setAttribute('src', src);
        img.removeAttribute('data-dropdown-img-src');
      }
      
      // Set srcset for responsive images
      if (srcset) {
        img.setAttribute('srcset', srcset);
        img.removeAttribute('data-dropdown-img-srcset');
      }
      
      // Set sizes for responsive images
      if (sizes) {
        img.setAttribute('sizes', sizes);
        img.removeAttribute('data-dropdown-img-sizes');
      }
    });
    
    imagesLoaded = true;
    
    // Remove event listeners after loading to improve performance
    removeEventListeners();
  }
  
  /**
   * Remove all event listeners after images are loaded
   */
  function removeEventListeners() {
    const menuSelectors = ['#menu-top-menu', '#menu-main-menu'];
    
    menuSelectors.forEach(selector => {
      const menu = document.querySelector(selector);
      if (menu) {
        menu.removeEventListener('click', loadDropdownImages);
        menu.removeEventListener('mouseenter', loadDropdownImages, true);
      }
    });
  }
  
  /**
   * Initialize dropdown lazy load
   */
  function init() {
    const menuSelectors = ['#menu-top-menu', '#menu-main-menu'];
    
    menuSelectors.forEach(selector => {
      const menu = document.querySelector(selector);
      if (menu) {
        // Load on click (primary trigger)
        menu.addEventListener('click', loadDropdownImages);
        
        // Also load on hover for better UX (optional)
        // Using capture phase to catch events from child elements
        menu.addEventListener('mouseenter', loadDropdownImages, true);
      }
    });
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

